import type { ContestBasis, SchedulePeriodStatus, WorkerRunOutcome } from '../types.js'

export const RUN_OUTCOME_LABEL: Record<WorkerRunOutcome, string> = { scheduled: 'Scheduled', assigned: 'Assigned', no_preferences: 'No preferences', nothing_fit: 'Nothing fit' }
export const RUN_OUTCOME_CLASS: Record<WorkerRunOutcome, string> = { scheduled: 'text-green', assigned: 'text-marine', no_preferences: 'text-coral', nothing_fit: 'text-coral' }
export const CONTEST_BASIS_LABEL: Record<ContestBasis, string> = { tier: 'higher tier', score: 'higher score', seniority: 'longer service', order: 'first in order' }
export const PERIOD_STATUS_LABEL: Record<SchedulePeriodStatus, string> = { bidding: 'Taking preferences', closed: 'Preferences closed', built: 'Built, not released', released: 'Released' }
export const PERIOD_STATUS_CLASS: Record<SchedulePeriodStatus, string> = { bidding: 'bg-gold/30 text-ink border-gold', closed: 'bg-canvas text-ink-mid border-marine/20', built: 'bg-marine/10 text-marine border-marine/30', released: 'bg-green/15 text-green border-green/50' }

/**
 * The status chip for a month: its status, except that a month nobody on the
 * roster bids for (every tier assigned) is not waiting on preferences, open or
 * closed - it is ready to build once its shifts are published. `bidding` is
 * the roster's bidders; unknown (an older API) reads the status as it is.
 */
export function periodStatusChip(status: SchedulePeriodStatus, bidding: number | undefined, rosterSize?: number): { label: string; className: string } {
  const nobodyBids = bidding === 0 && (rosterSize === undefined || rosterSize > 0)
  if (nobodyBids && (status === 'bidding' || status === 'closed')) {
    return { label: 'No preferences needed', className: 'bg-marine/10 text-marine border-marine/30' }
  }
  return { label: PERIOD_STATUS_LABEL[status], className: PERIOD_STATUS_CLASS[status] }
}

/** "Feb 1, 12:00 AM" from an instant, in the viewer's zone. */
export function formatRunInstant(iso: string): string {
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/** "20 shifts · 160 hrs". */
export function describeAwarded(awarded: readonly unknown[], hours: number): string {
  return `${awarded.length} ${awarded.length === 1 ? 'shift' : 'shifts'} · ${hours} hrs`
}

/** Why a PTO day stands as it does, in the manager's words. */
export const PTO_REASON_TEXT: Record<string, string> = {
  first_pto_day_denied: 'the tier works its first PTO day',
  below_minimum: 'the unit would fall below its minimum staffing',
  coverage_met: 'staffing holds without them',
  no_staffing_minimum_to_judge_by: 'no staffing minimum to judge by',
}
